/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type devices_DeviceSelfResponse = {
    /**
     * ChildcareID is the Kita the device belongs to (#2023: door mode shows its groups).
     */
    childcareId: string;
    childcareName: string;
    deviceId: string;
    name: string;
    /**
     * Status is "revoked" once an admin revoked the device.
     */
    status: devices_DeviceSelfResponse.status;
};
export namespace devices_DeviceSelfResponse {
    /**
     * Status is "revoked" once an admin revoked the device.
     */
    export enum status {
        ACTIVE = 'active',
        REVOKED = 'revoked',
    }
}

